<template>
  <div v-if="message" :key="showCount" class="modal-toaster">
    {{ message }}
  </div>
</template>

<script>
// Transient hint inside a modal, e.g. "you need to get the previous offer
// first". Place it in a positioned container and call
// `this.$refs.<ref>.show(this.$t("some.key"))`; it hides itself again.
export default {
  name: "ModalToaster",
  props: {
    duration: {
      type: Number,
      default: 2500,
    },
  },
  data() {
    return {
      message: "",
      timer: null,
      // Re-keys the element, so the buzz replays on every show.
      showCount: 0,
    };
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    show(message) {
      this.message = message;
      this.showCount++;
      clearTimeout(this.timer);
      this.timer = setTimeout(this.hide, this.duration);
    },
    hide() {
      clearTimeout(this.timer);
      this.message = "";
    },
  },
};
</script>

<style scoped lang="scss">
.modal-toaster {
  position: absolute;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  z-index: 20;
  padding: 10px 22px;
  border-radius: 22px;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  white-space: nowrap;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);
  pointer-events: none;
  animation: modal-toaster-buzz 0.4s ease-in-out;
}

// translateX(-50%) kept in every frame -- it centres the toaster.
@keyframes modal-toaster-buzz {
  0%,
  100% {
    transform: translateX(-50%);
  }
  20%,
  60% {
    transform: translateX(calc(-50% - 6px));
  }
  40%,
  80% {
    transform: translateX(calc(-50% + 6px));
  }
}
</style>
